import { i18n } from '../../../../../language';
import BasePop from './BasePop';

const SettingDiagnosisAddoption = ({ open, closePop, firstBtnClick, secondBtnClick }) => {
  const props = {
    title: i18n.t('BEDSTATUS_ADD_DIAGNOSIS'),
    subTitle: i18n.t('BEDSTATUS_DIAGNOSIS_NAME'),
    showActive: false,
    firstBtnText: i18n.t('BEDSTATUS_CANCEL'),
    secondBtnText: i18n.t('BEDSTATUS_ADD'),
    closePop,
    open,
    firstBtnClick,
    secondBtnClick,
  };
  return <BasePop {...props} />;
};

const SettingDiagnosisEditoption = ({ open, closePop, firstBtnClick, secondBtnClick, inputName, active }) => {
  const props = {
    title: i18n.t('BEDSTATUS_EDIT_DIAGNOSIS'),
    subTitle: i18n.t('BEDSTATUS_DIAGNOSIS_NAME'),
    showActive: true,
    firstBtnText: i18n.t('BEDSTATUS_DELETE_ITEM'),
    secondBtnText: i18n.t('BEDSTATUS_SAVE'),
    active,
    closePop,
    open,
    firstBtnClick,
    secondBtnClick,
    inputName,
  };
  return <BasePop {...props} />;
};

const SettingRemarksAddoption = ({ open, closePop, firstBtnClick, secondBtnClick }) => {
  const props = {
    title: i18n.t('BEDSTATUS_ADD_REMARKS'),
    subTitle: i18n.t('BEDSTATUS_REMARKS_NAME'),
    showActive: true,
    firstBtnText: i18n.t('BEDSTATUS_CANCEL'),
    secondBtnText: i18n.t('BEDSTATUS_ADD'),
    closePop,
    open,
    firstBtnClick,
    secondBtnClick,
  };
  return <BasePop {...props} />;
};

const SettingRemarksEditoption = ({ open, closePop, firstBtnClick, secondBtnClick, inputName, active }) => {
  const props = {
    title: i18n.t('BEDSTATUS_EDIT_REMARKS'),
    subTitle: i18n.t('BEDSTATUS_REMARKS_NAME'),
    showActive: true,
    firstBtnText: i18n.t('BEDSTATUS_DELETE_ITEM'),
    secondBtnText: i18n.t('BEDSTATUS_SAVE'),
    active,
    closePop,
    open,
    firstBtnClick,
    secondBtnClick,
    inputName,
  };
  return <BasePop {...props} />;
};

export { SettingDiagnosisAddoption, SettingDiagnosisEditoption, SettingRemarksAddoption, SettingRemarksEditoption };
